var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBadge',{attrs:{"color":_vm.color,"size":"sm"}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }